export const customTableSchemaKey = slug => ["custom-table-schema", slug];
export const customTableName = slug => `custom_table_${slug}`;

// BaseTableV3 keys its row-list query on `[customTableQueryKey(slug),
// queryParams]`, so this string is the prefix every grid refetch matches on.
export const customTableQueryKey = slug => `custom-table-rows-${slug}`;

// Invalidation key for the row list. It must prefix-match the grid query above
// or `invalidateQueries` is a silent no-op and the grid never refetches after a
// mutation (create/update/delete) or a tag change. Keep it aligned with
// `customTableQueryKey`.
export const customTableRowsKey = slug => [customTableQueryKey(slug)];
